<div class="d-flex flex-column roi-nubers" *ngIf="showPage">
  <div class="d-flex flex-column fee-section">
    <div class="d-flex flex-column mb-3 roi-fee-top-row">
      <span class="curb-fee">Third Party</span>
      <div class="third-party-fee third-party-fee-top mb-3">
        <div class="d-flex align-items-center">
          <div>Third Party Fee</div>
          <div class="ps-3">
            <input class="margin-bottom-0 float-left" placeholder="Amount" type="text" [(ngModel)]="feeLineData.thirdPartyFee" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="onThirdPartyFeeBlur()"/>
          </div>
        </div>
      </div>
    </div>

     <span class="curb-fee">CURB Fee</span>
    <div class="mb-2">
      <div class="mb-2">
        Type of Fee
        <span class="text-center  badge-tooltip move-right">
          <i class="icon ion-ios-information-outline"></i>
          <span class="tooltip-text text-blue" style="width: 300px; font-size: 12px; padding: 5px;">
            Indicates whether the fee is a one-time charge or a recurring subscription/payment for ongoing services. The selected type will also apply to prior fees paid and third-party fees. During the RAP (Review & Proposal) phase, enter one fee, then add more from the Plan Input tab as needed.
          </span>
        </span>
      </div>
      <div class="d-flex mb-2">
        <div class="pe-5">
          <input type="radio" name="feeType" value="{{feeLineData.type}}" (click)="setTypeOfFee('One Time')" [checked]="feeLineData.type === 'One Time'"/>
          One-Time
        </div>
        <div class="pe-5">
          <input type="radio" name="feeType" value="{{feeLineData.type}}" (click)="setTypeOfFee('Recurring')" [checked]="feeLineData.type === 'Recurring'"/>
          Recurring
        </div>
      </div>
    </div>
    <div class="d-flex flex-column suggest-fee-section">
      
      <div class="d-flex">
        <div>
          <span class="text-center badge-tooltip">
            <i class="icon ion-android-bulb suggest-bulb" style="font-size: 23px;position: relative;bottom: 7px;"></i>
            <span class="rightTooltiptext" style="width: 300px; padding: 5px; text-align: left; font-size: 12px;">
              We suggest an ROI based fee between 200% (if CURB factors are high) to 400% (if CURB factors are low) by default, and then adjust higher or lower per preference. See <a style="text-decoration: underline;" href="https://www.taxplaniq.com/roi-method" target="_blank">ROI Method(tm)</a> to learn more.
            </span>
          </span>
        </div>
        <div>
          Suggest ROI Fee
          <span class="text-center badge-tooltip">
            <i class="icon ion-ios-information-outline"></i>
            <span class="bottomTooltiptext" style="width: 300px;padding: 5px;">
              Recommends a fee based on the estimated tax savings for the client, along with other intangible factors such as complexity, urgency, risk, and additional benefits. You can override any suggested amounts as needed.
            </span>
          </span>
        </div>
      </div>
      <div>
        <table style="margin-top: 0 !important;">
          <thead>
          <tr>
            <th class="pointer" *ngFor="let column of implementationFeeColumns">
              {{column.title}}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of implementationFeeTypes;let i=index">
            <td *ngFor="let col of implementationFeeColumns;let idx=index">
              <div *ngIf="col.name == 'type'">
                {{row[col.name]}}
                <span class="text-center badge-tooltip" *ngIf="row[col.name] == 'Select All'">
                  <i class="icon ion-ios-information-outline"></i>
                  <span class="rightTooltiptext" style="font-size: 12px; background-color: #14B5F0; width: 200px;">
                    Click on this to select all
                  </span>
                </span>
                <span class="text-center badge-tooltip" *ngIf="row[col.name] == 'Intangible Benefits'">
                  <i class="icon ion-ios-information-outline"></i>
                  <span class="rightTooltiptext" style="font-size: 12px; background-color: #14B5F0; width: 300px;">
                    Consider other services included in this work, including frequency of meetings with the client and other advisors, representation work, access to you as the expert, any guarantee, and other competitive advantages your firm has. Pricing should be based on the unique needs, circumstances, and desired outcomes of each client.
                  </span>
                </span>
                <span class="text-center badge-tooltip" *ngIf="row[col.name] == 'Urgency'">
                  <i class="icon ion-ios-information-outline"></i>
                  <span class="rightTooltiptext" style="font-size: 12px; background-color: #14B5F0; width: 300px;">
                    Consider the timing for the engagement. A quick turnaround may demand a higher price.
                  </span>
                </span>
                <span class="text-center badge-tooltip" *ngIf="row[col.name] == 'Complexity'">
                  <i class="icon ion-ios-information-outline"></i>
                  <span class="rightTooltiptext" style="font-size: 12px; background-color: #14B5F0; width: 300px;">
                    It is essential to evaluate the unique knowledge and experience that you and your team possess. Consider the specialized expertise required to perform the engagement and the level of skill and experience needed to deliver high-quality results.
                  </span>
                </span>
                <span class="text-center badge-tooltip" *ngIf="row[col.name] == 'Risk'">
                  <i class="icon ion-ios-information-outline"></i>
                  <span class="rightTooltiptext" style="font-size: 12px; background-color: #14B5F0; width: 300px;">
                    You should consider adjusting the pricing based on the assessed risk level. Higher-risk engagements may warrant higher fees to account for the additional effort, expertise, and potential liabilities involved. Conversely, lower-risk engagements may allow for more competitive pricing.
                  </span>
                </span>
              </div>
              <div *ngIf="col.name == 'high'">
                <input class="pointer" type="radio" name="priority{{i}}" value="{{row.priority}}" (click)="setImplementationFeePriority(row, col)" [checked]="row.high"/>
              </div>
              <div *ngIf="col.name == 'medium'">
                <input class="pointer" type="radio" name="priority{{i}}" value="{{row.priority}}" (click)="setImplementationFeePriority(row, col)" [checked]="row.medium"/>
              </div>
              <div *ngIf="col.name == 'low'">
                <input class="pointer" type="radio" name="priority{{i}}" value="{{row.priority}}" (click)="setImplementationFeePriority(row, col)" [checked]="row.low"/>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex flex-column proposed-fee">
        <div class="d-flex align-items-baseline proposed-calc-fee">
          <div>Proposed fee(Calculated for Est Yr1 Savings <span class="fee-color">{{year1Savings | formatAmount:'$0,0'}}</span>) : </div>
          <div class="d-flex ps-3 proposed-fee-input">
            <input class="fee-color margin-bottom-0" [ngClass]="{'manual-input': calculatedY1ImplementationFee != finalY1ImplementationValue}" type="text" [(ngModel)]="finalY1ImplementationValue" model-numeral [format]="'$0,0'" [locale]="'usd'" (blur)="roundOffTheValue(finalY1ImplementationValue)"/>
            <ng-template [ngIf]="calculatedY1ImplementationFee != finalY1ImplementationValue">
              <span class="pointer reset-amount" (click)="calculateImplementationFee()">Reset</span>
              <span class="text-center badge-tooltip field-position">
                <img class="info-icon" src="../../../../images/core-focus/orange-info-icon.png"/>
                <span class="bottomTooltiptext">
                  This is a manually entered fee which is overriding the CURB proposed fee. Click Reset to revert to the CURB proposed fee.
                </span>
              </span>
            </ng-template>
          </div>
        </div>
        <div class="proposed-calc-fee mt-2 mb-2">
          <span>Yr2 and forward consideration(Yr2 and forward Savings : <span class="fee-color">{{(year2Savings || 0) | formatAmount:'$0,0'}}</span>) : <span class="fee-color">{{finalY2ImplementationValue | formatAmount:'$0,0'}}</span></span>
        </div>
      </div>
    </div>
    <div class="d-flex mt-2 mb-2">
      
      <div class="d-flex flex-column w-100">
        <div>
          <label>Select Rate</label>
        </div>
        <div>
          <app-tpiq-select-dropdown [setData]="associatedWith" [includeNone]="false" (onValueSelect)="setAssociatedWithForFeeItem($event)"
                                 [setDefaultValue]="feeLineData.associatedWith || ''" [setSearchKey]="'name'" [setPlaceHolder]="'Select Rate'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
        </div>
      </div>
    </div>
    <div class="d-flex mt-2 mb-2">
      <div class="d-flex flex-column w-100 suggest-fee-info-field">
        <div>
          <label>Frequency</label>
        </div>
        <div *ngIf="feeLineData.type === 'Recurring'">
          <app-tpiq-select-dropdown [setData]="feePeriods" [includeNone]="false" (onValueSelect)="setPeriod($event)"
                                 [setDefaultValue]="feeLineData.frequency || 'Yearly'" [setSearchKey]="'name'" [setPlaceHolder]="'Frequency'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
        </div>
        <div *ngIf="feeLineData.type !== 'Recurring'">
          <input type="text" placeholder="Frequency" disabled/>
        </div>
      </div>
      <div class="d-flex flex-column w-100" *ngIf="feeLineData.frequency != 'Custom'">
        <div>
          <label>Select Year</label>
        </div>
        <div>
          <app-tpiq-select-dropdown [setData]="years" [includeNone]="false" (onValueSelect)="setYear($event)"
                                 [setDefaultValue]="feeLineData.year" [setSearchKey]="'name'" [setPlaceHolder]="feeLineData.type == 'Recurring'? 'Start Year': 'Year'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
        </div>
      </div>
      <div class="d-flex flex-column w-100" *ngIf="feeLineData.frequency === 'Custom'">
        <div>
          <label>Select Date Range<span style="color: red">*</span></label>
        </div>
        <div class="range-date-picker">
          <label>
             <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="minDate" [(ngModel)]="feeLineData.fromMonth"
                       (valueChanged)="onDate($event, 'start')"  placeholder="Start Date(MM DD YYYY)"/>


             <input class="float-left input-field" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="minDate" [(ngModel)]="feeLineData.toMonth"
            (valueChanged)="onDate($event, 'end')"  placeholder="End Date(MM DD YYYY)"/>
          </label>
        </div>
      </div>

    </div>
    <div class="d-flex flex-column mt-2 mb-2">
      <div>
        <label>Description</label>
      </div>
      <div>
        <label>
          <textarea placeholder="Enter description here..." [(ngModel)]="feeLineData.description" rows="4"></textarea>
        </label>
      </div>
    </div>
    
     <div class="sec-title">Prior Fees</div>
    <div class="prior-fees">     
      <div class="d-flex gap-2 w-100 suggest-fee-info-field align-items-center">
        <label class="d-flex align-items-center gap-1 text-nowrap">
          Prior Fee's Paid
          <span class="text-center badge-tooltip move-right">
            <i class="icon ion-ios-information-outline"></i>
            <span class="tooltip-text text-blue text-wrap" style="width: 250px; font-size: 12px;               ">
              If prior fees paid toward work, put that amount here to offset the final ROI. For example tax prep fees included in this new offering.
            </span>
          </span>
        </label>
        <input class="float-left mb-0 w-auto" placeholder="Amount" type="text" [(ngModel)]="feeLineData.amount" model-numeral [locale]="'USD'" [format]="'$0,0'" (blur)="roundOffTheValue(feeLineData.amount)"/>
      </div>
    </div>
  </div>
  <div class="d-flex flex-column mt-3 disclaimer">
    <div class="bold">Disclaimer:</div>
    <div>
      <p style="font-size: 0.8rem;">Any pricing suggestions are provided for informational purposes only and should always be adjusted for the client's individual situation. The estimates are based on a minimum income generation, using The <a style="text-decoration: underline;" href="https://www.taxplaniq.com/roi-method" target="_blank">ROI Method(tm)</a> (Return on Investment), of 200% for the most complex engagements. For those less complex, the ROI estimate may increase up to 400%. Please note that these are general guidelines and the specific ROI can vary outside of these parameters depending on the nature of the value priced engagement. Determine the appropriate pricing strategy based on the value provided (including intangible services), strictly at your own risk. The user is responsible for evaluating the suggestions and making their own decisions and adjustments to comply with any applicable professional standards and regulations. This information is not intended to replace professional judgment and should not be considered as legal or financial advice.</p>
    </div>
  </div>
</div>
